import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/QR code.svg` */
export const QrCodeIcon = createTripletGlyphIcon('QrCodeIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.80225 9.74854H11.1274V8.42139H12.4614V9.75244H13.7954V11.0854H12.4624V12.4097H13.7954V13.7437H12.4624V12.4155H11.1343V13.7417H9.80127V12.4097H8.46924V11.0767H9.79541V9.75146H8.46924V8.41748H9.80225V9.74854ZM11.1294 11.0825H9.80225V12.4087H11.1294V11.0825L12.4614 11.0815V9.75537H11.1294V11.0825Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.93604 8.74268C6.44045 8.79373 6.83447 9.21991 6.83447 9.73779V12.3677L6.82861 12.4692C6.78089 12.9401 6.40687 13.3141 5.93604 13.3618L5.83447 13.3677H3.20459L3.10205 13.3618C2.63154 13.3138 2.25713 12.9399 2.20947 12.4692L2.20459 12.3677V9.73779C2.20459 9.22017 2.598 8.79409 3.10205 8.74268L3.20459 8.73779H5.83447L5.93604 8.74268ZM3.20459 12.3677H5.83447V9.73779H3.20459V12.3677Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.93604 2.26123C6.44045 2.31228 6.83447 2.73846 6.83447 3.25635V5.88623L6.82861 5.98779C6.78083 6.45855 6.40682 6.83269 5.93604 6.88037L5.83447 6.88623H3.20459L3.10205 6.88037C2.63158 6.83237 2.25719 6.45834 2.20947 5.98779L2.20459 5.88623V3.25635C2.20459 2.73873 2.59801 2.31265 3.10205 2.26123L3.20459 2.25635H5.83447L5.93604 2.26123ZM3.20459 5.88623H5.83447V3.25635H3.20459V5.88623Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4194 2.26123C12.9236 2.31252 13.3179 2.73864 13.3179 3.25635V5.88623L13.312 5.98779C13.2643 6.45842 12.89 6.83249 12.4194 6.88037L12.3179 6.88623H9.68799L9.58545 6.88037C9.11494 6.83243 8.74062 6.45836 8.69287 5.98779L8.68799 5.88623V3.25635C8.68799 2.73867 9.08132 2.31256 9.58545 2.26123L9.68799 2.25635H12.3179L12.4194 2.26123ZM9.68799 5.88623H12.3179V3.25635H9.68799V5.88623Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0278 10.9673H12.5181V9.4751H14.0181V10.9751H12.52V12.4673H11.0269V13.9595H12.52V12.4673H14.019V10.9712H15.519V12.4712H14.02V13.9614H15.52V15.4614H14.02V13.9673H12.5259V15.4595H11.0259V13.9614H9.52686V12.4614H11.02V10.9702H9.52783V9.47021H11.0278V10.9673Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.68799 9.83057C7.24027 9.83057 7.68799 10.2783 7.68799 10.8306V14.0386C7.68776 14.5907 7.24013 15.0386 6.68799 15.0386H3.47998L3.37744 15.0337C2.87358 14.9823 2.4802 14.556 2.47998 14.0386V10.8306C2.47998 10.2784 2.92783 9.83072 3.47998 9.83057H6.68799ZM3.57959 13.939H6.58838V10.9302H3.57959V13.939Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.68799 2.53857C7.24027 2.53857 7.68799 2.98629 7.68799 3.53857V6.74658C7.68781 7.29872 7.24016 7.74658 6.68799 7.74658H3.47998L3.37744 7.7417C2.87353 7.69027 2.48015 7.26403 2.47998 6.74658V3.53857C2.47998 2.98637 2.92781 2.53871 3.47998 2.53857H6.68799ZM3.57959 6.64697H6.58838V3.63818H3.57959V6.64697Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.981 2.53857C14.5332 2.53857 14.981 2.98629 14.981 3.53857V6.74658C14.9808 7.29875 14.5332 7.74658 13.981 7.74658H10.7729L10.6704 7.7417C10.1665 7.69026 9.77308 7.26405 9.77295 6.74658V3.53857C9.77295 2.98638 10.2208 2.53872 10.7729 2.53857H13.981ZM10.8726 6.64697H13.8813V3.63818H10.8726V6.64697Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7031 14.623H16.6914V12.6328H18.6914V14.6328H16.6934V16.623H14.7031V18.6133H16.6934V16.623H18.6924V14.6289H20.6924V16.6289H18.6934V18.6152H20.6934V20.6152H18.6934V18.623H16.7012V20.6133H14.7012V18.6152H12.7031V16.6152H14.6934V14.627H12.7031V12.627H14.7031V14.623Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9043 13.1143C9.66054 13.1911 10.2508 13.83 10.251 14.6064V18.5508L10.2432 18.7041C10.1715 19.41 9.61024 19.9713 8.9043 20.043L8.75098 20.0508H4.80664L4.65332 20.043C3.94748 19.9712 3.38615 19.41 3.31445 18.7041L3.30664 18.5508V14.6064C3.30684 13.83 3.89714 13.1911 4.65332 13.1143L4.80664 13.1064H8.75098L8.9043 13.1143ZM4.80664 18.5508H8.75098V14.6064H4.80664V18.5508Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9043 3.39258C9.66067 3.4694 10.251 4.10812 10.251 4.88477V8.8291L10.2432 8.98242C10.1713 9.6882 9.61013 10.2496 8.9043 10.3213L8.75098 10.3291H4.80664L4.65332 10.3213C3.94755 10.2495 3.38628 9.68817 3.31445 8.98242L3.30664 8.8291V4.88477C3.30664 4.1082 3.89705 3.4695 4.65332 3.39258L4.80664 3.38477H8.75098L8.9043 3.39258ZM4.80664 8.8291H8.75098V4.88477H4.80664V8.8291Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6289 3.39258C19.3851 3.46953 19.9756 4.10822 19.9756 4.88477V8.8291L19.9678 8.98242C19.896 9.68816 19.3347 10.2495 18.6289 10.3213L18.4756 10.3291H14.5312L14.3779 10.3213C13.6721 10.2496 13.1109 9.68822 13.0391 8.98242L13.0312 8.8291V4.88477C13.0312 4.1081 13.6215 3.46938 14.3779 3.39258L14.5312 3.38477H18.4756L18.6289 3.39258ZM14.5312 8.8291H18.4756V4.88477H14.5312V8.8291Z"
        fill="currentColor"
      />
    </svg>
  ),
});
